export default __webpack_public_path__ + "static/media/NotoSans-BoldItalic.b8f68f12.eot";